import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Create from './Create';
import Edit from './Edit';
import Delete from './Delete';

import { translate } from 'translations/i18n';

const Container = styled.div`
  background-color: var(--cc_color_background_2);
  overflow: auto;
  padding: 24px;
  margin-right: 24px;
  border-radius: 12px;
  align-self: flex-start;
  position: sticky;
  top: 86px;
`;

const EmptyState = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15%;
  color: var(--cc_color_text_default);
  font-size: 16px;
  line-height: 23px;

  h3 {
    font-size: 22px;
    line-height: 26px;
    margin-bottom: 16px;
    text-align: center;
  }

  p {
    text-align: center;
  }
`;

const SnippetEditor = ({
  snippets,
  selectedText,
  selectedSnippet,
  isCreating,
  isDeleting,
  insertSnippet,
  handleSelectSnippet,
  handleSelectDelete,
  handleCancel,
  handleDeleteCancel,
}) => {
  return (
    <Container>
      {selectedSnippet && !isDeleting ? (
        <Edit
          snippet={selectedSnippet}
          insertSnippet={insertSnippet}
          handleSelectDelete={handleSelectDelete}
        />
      ) : null}
      {isCreating ? (
        <Create
          selectedText={selectedText}
          handleCancel={handleCancel}
          handleSelectSnippet={handleSelectSnippet}
        />
      ) : null}
      {isDeleting ? (
        <Delete snippet={selectedSnippet} handleCancel={handleDeleteCancel} />
      ) : null}
      {!isCreating &&
        !selectedSnippet &&
        !isDeleting &&
        snippets.length !== 0 && (
          <EmptyState>
            <p>{translate('snippets.snippetEditor.snippetsDetailMsg')}</p>
          </EmptyState>
        )}
      {!isCreating &&
        !selectedSnippet &&
        !isDeleting &&
        snippets.length === 0 && (
          <EmptyState>
            <h3>{translate('snippets.snippetEditor.snippetsInfoHeader')}</h3>
            <p>{translate('snippets.snippetEditor.snippetsInfoContent')}</p>
          </EmptyState>
        )}
    </Container>
  );
};
SnippetEditor.propTypes = {
  snippets: PropTypes.array,
  selectedText: PropTypes.string,
  selectedSnippet: PropTypes.object,
  isCreating: PropTypes.bool,
  isDeleting: PropTypes.bool,
  insertSnippet: PropTypes.func,
  handleSelectSnippet: PropTypes.func,
  handleSelectDelete: PropTypes.func,
  handleCancel: PropTypes.func,
  handleDeleteCancel: PropTypes.func,
};

export default SnippetEditor;
